// extracted by mini-css-extract-plugin
export default {"wholeWrapper":"HomeAdSlideStatus_wholeWrapper__8fqlU","status":"HomeAdSlideStatus_status__L5hnv"};